import React from "react";

function WhyWeNeedTextSummarizer() {
  return (
    <div>
      <div className="container" style={{ marginTop: "7rem" }}>
        {/* Title section */}
        <div>
          {/* Why do we need text summarizer */}
          <h1 className="display-6">Why Do We Need a Text Summarizer?</h1>
        </div>

        {/* Description */}
        <div className="mt-5">
          <h5 className="lead fs-4">
            <b>Save Time:</b>
          </h5>
          <p className="lead fs-5">
            Text summarizers quickly condense long articles, documents, or
            reports into short, readable summaries — helping users get the main
            idea without reading everything.
          </p>
        </div>

        <div className="mt-3">
          <h5 className="lead fs-4">
            <b>Improve Productivity:</b>
          </h5>
          <p className="lead fs-5">
            Professionals, students, and researchers can focus on key points
            instead of spending hours reading through large volumes of text.
          </p>
        </div>

        <div className="mt-3">
          <h5 className="lead fs-4">
            <b>Better Decision-Making:</b>
          </h5>
          <p className="lead fs-5">
            By summarizing data or content, it becomes easier to understand and
            analyze information, leading to faster and more informed decisions.
          </p>
        </div>

        <div className="mt-3">
          <h5 className="lead fs-4">
            <b>Enhance Learning:</b>
          </h5>
          <p className="lead fs-5">
            Students can use summarizers to review large study materials,
            essays, or textbook chapters more efficiently.
          </p>
        </div>

        <div className="mt-3">
          <h5 className="lead fs-4">
            <b>Boost SEO and Content Marketing:</b>
          </h5>
          <p className="lead fs-5">
            Marketers can use summarizers to repurpose blog posts, generate meta
            descriptions, and create concise previews for sharing on social
            media.
          </p>
        </div>
      </div>
    </div>
  );
}

export default WhyWeNeedTextSummarizer;
